<div class="action-toolbar">
  <ng-content></ng-content>
</div>
